<template>
	<div class="body">
		<Header/>
		<main class="content container mx-auto relative pt-12 md:pt-20">
			<div class="max-md:hidden absolute -top-14 right-0 lg:right-28">
				<svg xmlns="http://www.w3.org/2000/svg" width="200" height="177" viewBox="0 0 200 177" fill="none">
					<path d="M74.1068 0.916463C74.1068 17.7481 87.7515 31.3928 104.583 31.3928" stroke="#070A26"
						  stroke-width="19.0477"/>
					<path d="M150.893 96.7502C150.893 79.9186 137.249 66.2738 120.417 66.2738" stroke="#070A26"
						  stroke-width="19.0477"/>
					<path d="M70.4764 137C70.4764 120.168 56.8316 106.524 40 106.524" stroke="#070A26" stroke-width="19.0477"/>
					<path d="M0.000368693 167.476C16.8319 167.476 30.4766 153.832 30.4766 137" stroke="#070A26"
						  stroke-width="19.0477"/>
					<path d="M160 127.476C176.832 127.476 190.477 113.832 190.477 97" stroke="#070A26" stroke-width="19.0477"/>
				</svg>
			</div>
			<section>
				<span class="block mb-6 text-sm">{{ data?.data?.attributes.preTitle }}</span>
				<h1 class="font-medium text-2xl md:text-5xl text-balance">{{ data?.data?.attributes.title }}</h1>
			</section>
			<article>
				<NuxtLink :to="'/' +posts.data[0].attributes.category.data?.attributes.slug + '/' + posts.data[0].attributes.slug">
					<div class="mt-8 w-full h-52 md:h-[400px] relative rounded-lg drop-shadow-lg overflow-hidden">
						<NuxtPicture v-if="posts.data[0]?.attributes.blogImage.data?.attributes.hash"
									 
									 loading="eager"
									 preload
									 :src="posts.data[0]?.attributes.blogImage.data?.attributes.hash"
									 :imgAttrs="{
                          class:'absolute inset-0 h-full w-full object-cover',
                          
                       }"
						/>
					</div>
					<div class="mt-6 md:flex justify-between">
						<div>
							<h2 class="font-medium text-xl md:text-2xl max-w-md text-balance">{{ posts.data[0].attributes.title }}</h2>
						</div>
						<div>
							<div v-if="posts.data[0].attributes.employee" class="flex items-center gap-2">
								<div class="max-md:hidden relative h-5 w-5 rounded-full overflow-hidden bg-black">
									<NuxtPicture v-if="posts.data[0]?.attributes.employee.data?.attributes.thumbnail.data?.attributes.hash"
												 
												 loading="lazy"
												 :src="posts.data[0]?.attributes.employee.data?.attributes.thumbnail.data?.attributes.hash"
												 :imgAttrs="{
                                class:'absolute inset-0 object-cover w-full h-full',
                                
                            }"
									/>

									<div v-if="!posts.data[0]?.attributes.employee.data?.attributes.thumbnail.data?.attributes.hash" class="absolute inset-0 w-full h-full flex items-center justify-center">
									<div class="w-3 h-3">
									<svg class="w-full h-full" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M16.7619 31.9999C16.7619 41.2572 9.25732 48.7618 0 48.7618L6.66077e-07 63.9998C17.6563 63.9998 31.9727 49.7002 31.9999 32.0503C32.027 49.7003 46.3434 64 63.9998 64L63.9998 48.7619C54.7424 48.7619 47.2379 41.2574 47.2379 32.0001L16.7619 31.9999Z" fill="white"/>
										<path d="M48.7618 32C48.7618 22.7427 41.2572 15.2382 31.9999 15.2382C22.7426 15.2382 15.2381 22.7426 15.2381 31.9999L6.97341e-05 31.9999C6.89616e-05 14.3269 14.3269 7.72514e-07 32 0C49.673 3.50524e-05 63.9998 14.327 63.9998 32H48.7618Z" fill="white"/>
									</svg>
									</div>
								</div>

								</div>
								<h5 class="max-md:hidden text-sm text-balance">{{ posts.data[0].attributes.employee.data?.attributes.name }}</h5>
								<div class="max-md:mt-4">
									<time class="text-black/50 text-sm" :datetime="posts.data[0].attributes.publishedAt">
										{{ formattedDate(posts.data[0].attributes.publishedAt) }}
									</time>
								</div>
							</div>
						</div>
					</div>
				</NuxtLink>
			</article>
			<section class="mt-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
				<article v-for="post in posts.data">
					<NuxtLink :to="'/' + post.attributes.category.data?.attributes.slug + '/' + post.attributes.slug">
						<div class="mt-8 w-full h-52 md:h-60 relative rounded-lg overflow-hidden bg-light-grey">
							<NuxtPicture v-if="post?.attributes.blogImage.data?.attributes.hash"
										 
										 loading="lazy"
										 :src="post?.attributes.blogImage.data?.attributes.hash"
										 :imgAttrs="{
                          class:'absolute inset-0 h-full w-full object-cover',
                          
                       }"
							/>
							<span v-if="post.attributes.category.data" class="absolute top-3 left-3 z-10 block text-xxs px-3 py-1 text-white bg-pink rounded-full">{{ post.attributes.category.data?.attributes.name }}</span>
						</div>
						<div class="grid gap-6 my-6">
							<h2 class="font-medium text-lg text-balance">{{ post.attributes.title }}</h2>
							<time class="text-black/50 text-sm" :datetime="post.attributes.publishedAt">
								{{ formattedDate(post.attributes.publishedAt) }}
							</time>
						</div>
					</NuxtLink>
				</article>
			</section>
		</main>
		<Footer/>
	</div>
</template>

<script setup lang="ts">
import {useFetch} from "nuxt/app";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";

const runtimeConfig = useRuntimeConfig();
const { data, pending } = await useFetch(runtimeConfig.public.STRAPI_API_URL + '/blog-archive?pLevel', {
	 headers: {
      "Strapi-Response-Format": "v4",
    }
});
const {data: posts, pending: pendingPosts} = useFetch(runtimeConfig.public.STRAPI_API_URL + '/blog-posts?sort[0]=publishedAt:desc&pLevel', {
	 headers: {
      "Strapi-Response-Format": "v4",
    }
});

const seoData = data?.value?.data?.attributes?.seo || {};
const { data: globalSeoData } = await useFetch(runtimeConfig.public.STRAPI_API_URL + '/global-seo-setting?pLevel', {
	 headers: {
      "Strapi-Response-Format": "v4",
    }
});
const seoDataNoIndex = seoData.noIndex ?? false;
const seoDataTitle = seoData.pageTitle;
const seoDataDescription = seoData.shortDescription;
const seoDataCanonicalUrl = seoData.canonicalURL
const seoDataOgTitle = seoData.ogTitle ?? seoDataTitle
const seoDataOgDescription = seoData.ogDescription  ?? seoDataDescription
const seoDataOgImage = seoData?.image?.data ?? globalSeoData?.value?.data?.attributes?.ogImage.data;
const seoDataOgImageUrl = seoDataOgImage.attributes.url;



useSeoMeta({
  title: () => seoDataTitle,
  ogTitle: () => seoDataOgTitle,
  description: () => seoDataDescription,
  ogDescription:  () => seoDataOgDescription,
  ogImage: () => seoDataOgImageUrl,
})

useHead({
  meta: [
    seoDataNoIndex != false ? { name: 'robots', content: 'noindex, follow' } : {},
  ],
  script: [
    seoData.Schema != null ? { type: 'application/ld+json', innerHTML: seoData.Schema } : {},
    globalSeoData.value.data.attributes.globalSchema != {} ? { type: 'application/ld+json', innerHTML: globalSeoData.value.data.attributes.globalSchema } : {},
  ]
})

const formattedDate = ((originalDate: any) => {
	const dateObject = new Date(originalDate);
	return dateObject.toLocaleDateString("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric"
	});
});
</script>